module.exports = __webpack_public_path__ + "img/icon03.6e150a2e.png";